import { Offer } from './offer.model';

export enum LineType {
    primary = 'PrimaryLine',
    secondary = 'SecondaryLine',
    tertiary = 'TertiaryLine',
    product = 'ProductLine',
}

export interface QuoteAssignment {
    variableName: string;
    valueName?: string;
    valueText?: string;
    isUserAssignment?: boolean;
    isDefault?: boolean;
}

export interface QuotationQuoteLine {
    type: LineType;
    material: string;
    assignments: QuoteAssignment[];
}

export enum QuoteStatus {
    new = 'NEW',
    quoted = 'QUOTED',
    ordered = 'ORDERED',
    expired = 'EXPIRED',
}

export interface QuoteOfferExtraData {
    status: QuoteStatus;
    primarySchemes: string;
    secondarySchemes: string;
    emsScheme: string;
    energyLabelHash: string;
    externalApp?: string;
    planningType: string;
    noPriceAdvantage: boolean;
    lines: QuotationQuoteLine[];
}

export interface QuoteOffer extends Offer {
    extraData?: QuoteOfferExtraData;
}
